import { render, staticRenderFns } from "./contact_info.vue?vue&type=template&id=5fba1214&scoped=true&"
import script from "./contact_info.vue?vue&type=script&lang=js&"
export * from "./contact_info.vue?vue&type=script&lang=js&"
import style0 from "./contact_info.vue?vue&type=style&index=0&id=5fba1214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba1214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fba1214')) {
      api.createRecord('5fba1214', component.options)
    } else {
      api.reload('5fba1214', component.options)
    }
    module.hot.accept("./contact_info.vue?vue&type=template&id=5fba1214&scoped=true&", function () {
      api.rerender('5fba1214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/contact_info/contact_info.vue"
export default component.exports